import React from 'react'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { Control } from 'react-hook-form'
import { View } from 'react-native'
import { useStyleSheet, StyleService } from '@src/style/service'
import { Text } from '@components/base'
import { ScrollableAvoidKeyboard } from '@components'
import GiftIcon from '@assets/svgs/giftIcon'
import { ReferralCard } from './ReferralCard'

interface ReferralComponentProps {
  title: string
  description: string
  referralUrl: string
  sendInvite: () => void
  message?: string
  control: Control<{ email: string }>
}

export const ReferralComponent = (props: ReferralComponentProps) => {
  const { title, description, referralUrl, sendInvite, message, control } = props
  const styles = useStyleSheet(themedStyle)
  const insets = useSafeAreaInsets()

  return (
    <ScrollableAvoidKeyboard
      style={styles.scrollView}
      contentContainerStyle={[styles.content, { paddingBottom: insets.bottom + 16 }]}
      keyboardShouldPersistTaps="handled"
    >
      <View style={styles.headerIcon}>
        <GiftIcon height={70} />
      </View>
      <Text type="title-3" style={styles.title}>
        {title}
      </Text>
      <Text type="regular" style={styles.subtitle} numberOfLines={3}>
        {description}
      </Text>
      <ReferralCard
        control={control}
        referralUrl={referralUrl}
        sendInvite={sendInvite}
        message={message}
        showReferralUrl
        style={styles.referralCard}
      />
    </ScrollableAvoidKeyboard>
  )
}

const themedStyle = StyleService.create({
  scrollView: {
    flex: 1,
    backgroundColor: 'theme.background',
  },
  content: {
    alignItems: 'center',
  },
  headerIcon: {
    marginVertical: 20,
  },
  title: {
    textAlign: 'center',
  },
  subtitle: {
    marginTop: 12,
    marginHorizontal: 16,
    textAlign: 'center',
    color: 'theme.text.secondary',
  },
  referralCard: {
    marginHorizontal: 16,
  },
})
